import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import { RESET, SET_ALL_AUTHORITIES, SET_LOADING } from './actionTypes';
import STATUS_CODE from '../../../request/statusCode';
import {
  createAuthority,
  deleteAuthority,
  editAuthority,
  getAuthorities
} from './service';

const setAllAuthorities = createAction(SET_ALL_AUTHORITIES);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getAllAuthorities = () => {
  return dispatch => {
    dispatch(setLoading(true));
    return getAuthorities().then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        dispatch(setAllAuthorities(res.data));
        return;
      }
      dispatch(setAllAuthorities([]));
    });
  };
};

const create = ({ name, description, resource, requiredAuthority }) => {
  return dispatch => {
    return createAuthority({
      name,
      description,
      resource,
      requiredAuthority
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Authority added successfully !');
        dispatch(getAllAuthorities());
        return true;
      }
      return false;
    });
  };
};

const edit = ({ name, description, resource, requiredAuthority }) => {
  return dispatch => {
    return editAuthority({
      name,
      description,
      resource,
      requiredAuthority
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Authority edited successfully !');
        dispatch(getAllAuthorities());
        return true;
      }
      return false;
    });
  };
};

const remove = ({ name }) => {
  return dispatch => {
    return deleteAuthority({ name }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Authority deleted successfully !');
        dispatch(getAllAuthorities());
        return true;
      }
      return false;
    });
  };
};

export {
  setAllAuthorities,
  reset,
  getAllAuthorities,
  create,
  edit,
  remove,
  setLoading
};
